import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  kioskDetails: null,
  error: null
};

const kioskSlice = createSlice({
  name: "kiosk",
  initialState,
  reducers: {
    removeKioskData: (state) => {
      state.kioskDetails = null;
      state.loading = false;
      state.error = null;
    },
    OnLoadingKiosk: (state) => {
      state.loading = true;
    },
    OnSuccessKiosk: (state, action) => {
      state.kioskDetails = action.payload;
      state.loading = false;
      state.error = null;
    },
    updateKioskDetails: (state, action) => {
      state.kioskDetails = { ...state.kioskDetails, ...action.payload };
      state.loading = false;
    },
    OnFailureKiosk: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { 
  OnFailureKiosk, 
  OnSuccessKiosk, 
  OnLoadingKiosk, 
  updateKioskDetails, 
  removeKioskData 
} = kioskSlice.actions;

export const getKioskDetails = (state) => state.kiosk.kioskDetails;
export const getKioskLoading = (state) => state.kiosk.loading;

export default kioskSlice.reducer;
